import { useLayoutEffect, useMemo, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import TableLayout from "../../../components/TableLayout";
import { CommonToolTip, CstmPagination } from "../../../components/Common/Common";
import { generatePath, Link, useNavigate } from "react-router-dom";
import { successMessageToast } from "helpers/common";
import TableHeader from "components/shared/FormComponents/TableHeader";
import LoadingIndicator from "components/shared/LoadingIndicator";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { DeleteIcon, EditIcon } from "Assets/icons";
import { CHATTER_TEMPLATE_ADD, CHATTER_TEMPLATE_EDIT } from "config/paths";
import ErrorComponent from "components/shared/ErrorComponent";
import ConfirmationPop from "components/Modals/ConfirmationPop";
import { useDispatch, useSelector } from "react-redux";
import { chatterTemplatesFilter } from "store/slices/filter";
import { useDeleteChatterTemplateMutation, useGetChatterTemplateListQuery } from "store/services/chatterTemplate";
import AssignedTherapistList from "./Components/AssignedTherapistList";
import AllAssignedTherapistsPopup from "./Components/Modals/AllAssignedTherapistsPopup";
import useModal from "hooks/useModal";

const ChatterTemplates = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const filter = useSelector(state => state?.filter?.chatterTemplatesFilter);

  const [modalType, setModalType] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [currentEntry, setCurrentEntry] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const { show: showAllTherapistsPopup, data: allTherapistsData, open: openAllTherapistsPopup, close: closeAllTherapistsPopup } = useModal();

  const [schoolDivisons, setSchoolDivisons] = useState([]);
  const { data, isLoading, isError, isFetching } = useGetChatterTemplateListQuery({ page: currentPage, limit: pageSize, ...filter });
  const [deleteTemplate, { isLoading: deleteTemplateLoading }] = useDeleteChatterTemplateMutation();
  const totalRecords = data?.totalRecords || 0;
  const totalPages = Math.ceil(totalRecords / pageSize);

  const handleEditItem = (id) => {
    navigate(generatePath(CHATTER_TEMPLATE_EDIT, { id }));
  }

  const resetFilter = () => {
    dispatch(chatterTemplatesFilter({ search: "", status: "active", sort: { column: "id", direction: "desc" } }));
    setCurrentPage(1)
  };

  const handleDelete = async (id) => {
    try {

      setShowModal(false);

      // const list = [...schoolDivisons];
      // const index = schoolDivisons?.findIndex(x => x.id === currentEntry?.id);
      // delete list[index];
      // setSchoolDivisons(list.filter(Boolean));

      let result = await deleteTemplate({ id: currentEntry?.id });
      if (!result.error) {
        successMessageToast(result?.data?.message);
      }
    } catch (err) {
      console.log("error archiving discipline", err);
    }
  };

  const handlArchive = async () => {

    try {

      setShowModal(false);

      const list = [...schoolDivisons];
      const index = schoolDivisons?.findIndex(x => x.id === currentEntry?.id);
      list[index] = { ...list[index], status: list[index].status == "active" ? "archived" : "active" };
      setSchoolDivisons(list.filter(Boolean));

      const data = {
        title: currentEntry.title,
        status: currentEntry.status == "active" ? "archived" : "active",
      };

      const result = await updateSchoolDivison({ payload: data, id: currentEntry.id });
      if (!result?.error) successMessageToast(result?.data?.message);

    } catch (err) {
      console.error("error Archive manage status", err);
    };
  };


  const column = useMemo(() => ([
    {
      head: "Name",
      accessor: "title",
      sorter: true,
      isComponent: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-sbold">{item.program?.name}</h6>
      ),
    },
    {
      head: "Assigned To",
      isComponent: true,
      component: (item) => (
        <div>
          <AssignedTherapistList
            data={item?.chatterTemplateAssignedTherapists}
            handleShowAll={openAllTherapistsPopup}
          />
        </div>
      ),
    },
    {
      head: "Action",
      accessor: "",
      isComponent: true,
      component: (item) => (
        <div className="ActnBtn d-flex align-items-center  gap-10">
          <CommonToolTip
            text={"Edit"}
            component={<Button
              onClick={() => handleEditItem(item.id)}
              className="p-0"
              variant="transparent"
              type="button"
            >
              <EditIcon />
            </Button>}
          />
          {/* <CommonToolTip
              text={item?.status == "active" ? "Archive" : "Unarchive"}
              component={<Button
                onClick={(e) => {
                  e.stopPropagation()
                  setModalType(item?.status == "active" ? "archive" : "active");
                  setCurrentEntry(item);
                  setShowModal(true);
                }}
                className="p-0"
                variant="transparent"
                type="button"
              >
                {item?.status == "active" ? <ArchiveIcon /> : <UnArchiveIcon />}
              </Button>}
            /> */}
          <CommonToolTip
            text={"Delete"}
            component={<Button
              onClick={() => {

                setCurrentEntry(item);
                setModalType("delete");
                setShowModal(true);
              }}
              className="p-0"
              variant="transparent"
              type="button"
            >
              <DeleteIcon />
            </Button>}
          />
        </div>
      ),
    },
  ]), []);

  const handleFilterChange = (key) => (value) => {
    dispatch(chatterTemplatesFilter({ ...filter, [key]: value }))
    setCurrentPage(1); // Reset to first page when filter changes
  }

  const handlePageChange = (page) => {
    window.scrollTo(0, 0);
    setCurrentPage(page);
  }

  const handlePageSizeChange = (e) => {
    setPageSize(parseInt(e.target.value, 10));
    setCurrentPage(1); // Reset to first page when page size changes
  }

  useLayoutEffect(() => {

    if (data?.records) setSchoolDivisons(data?.records)
  }, [data]);

  return (
    <>
      <ConfirmationPop
        confirmation={showModal}
        setConfirmation={setShowModal}
        confirmHandler={modalType == "delete" ? handleDelete : handlArchive}
        type={modalType}
      />
      <AllAssignedTherapistsPopup
        showPopup={showAllTherapistsPopup}
        closePopup={closeAllTherapistsPopup}
        data={allTherapistsData}
      />
      <section className="School position-relative py-4">
        <Container fluid={true}>
          <Row>
            <Col lg="12" className="my-2">
              <TableHeader
                heading={"CHATTER Program Descriptions"}
                handleFilterChange={handleFilterChange}
                resetFilter={resetFilter}
                filter={filter}
                searchPlaceholder="Search by name"
                hideStatusFilter={true}
              >
                <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center justify-content-center flex-wrap gap-10">
                  <li className="">
                    <Link
                      to={CHATTER_TEMPLATE_ADD}
                      className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold "
                    >
                      <span className="icn me-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="19"
                          height="19"
                          viewBox="0 0 19 19"
                          fill="none"
                        >
                          <mask
                            id="mask0_0_4440"
                            style={{ maskType: "alpha" }}
                            maskUnits="userSpaceOnUse"
                            x="0"
                            y="0"
                            width="19"
                            height="19"
                          >
                            <rect
                              width="18.7197"
                              height="18.7197"
                              fill="#D9D9D9"
                            />
                          </mask>
                          <g mask="url(#mask0_0_4440)">
                            <path
                              d="M8.57996 13.2594H10.1399V10.1394H13.2599V8.57947H10.1399V5.45951H8.57996V8.57947H5.46V10.1394H8.57996V13.2594ZM9.35995 17.1593C8.28096 17.1593 7.26698 16.9546 6.31799 16.5451C5.369 16.1356 4.54352 15.5799 3.84153 14.8779C3.13954 14.1759 2.58379 13.3504 2.1743 12.4014C1.76481 11.4524 1.56006 10.4384 1.56006 9.35946C1.56006 8.28047 1.76481 7.26649 2.1743 6.3175C2.58379 5.36851 3.13954 4.54303 3.84153 3.84104C4.54352 3.13905 5.369 2.58331 6.31799 2.17381C7.26698 1.76432 8.28096 1.55957 9.35995 1.55957C10.4389 1.55957 11.4529 1.76432 12.4019 2.17381C13.3509 2.58331 14.1764 3.13905 14.8784 3.84104C15.5804 4.54303 16.1361 5.36851 16.5456 6.3175C16.9551 7.26649 17.1598 8.28047 17.1598 9.35946C17.1598 10.4384 16.9551 11.4524 16.5456 12.4014C16.1361 13.3504 15.5804 14.1759 14.8784 14.8779C14.1764 15.5799 13.3509 16.1356 12.4019 16.5451C11.4529 16.9546 10.4389 17.1593 9.35995 17.1593ZM9.35995 15.5994C11.1019 15.5994 12.5774 14.9949 13.7864 13.7859C14.9954 12.5769 15.5999 11.1014 15.5999 9.35946C15.5999 7.61748 14.9954 6.142 13.7864 4.93302C12.5774 3.72404 11.1019 3.11955 9.35995 3.11955C7.61797 3.11955 6.14249 3.72404 4.93351 4.93302C3.72453 6.142 3.12004 7.61748 3.12004 9.35946C3.12004 11.1014 3.72453 12.5769 4.93351 13.7859C6.14249 14.9949 7.61797 15.5994 9.35995 15.5994Z"
                              fill="white"
                            />
                          </g>
                        </svg>
                      </span>{" "}
                      Create New
                    </Link>
                  </li>
                </ul>
              </TableHeader>
              <div className="table-outer">
                {isLoading ? (
                  <div style={{ height: "200px" }}>
                    <LoadingIndicator />
                  </div>
                ) : isError ? (
                  <ErrorComponent />
                ) : (
                  <div>
                    {(isFetching || deleteTemplateLoading) && (
                      <LoadingOverlay />
                    )}
                    <TableLayout data={data?.records} column={column} filter={filter} handleSort={handleFilterChange("sort")} />
                  </div>
                )}
                <CstmPagination
                  totalPages={totalPages}
                  activePage={currentPage}
                  handlePageChange={handlePageChange}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ChatterTemplates;
